// extracted by mini-css-extract-plugin
export default {"container":"HealthcareReviewPage_container__SqIvw","loading":"HealthcareReviewPage_loading__VgTWk"};